<template>
  <div>
    <FormulateForm :schema="schema"
                   @submit="onSubmit"
                   v-model="values"></FormulateForm>
  </div>
</template>

<script>
export default {
  props: {
    conditions: {
      type: Object,
      required: true
    },
    schema: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      values: {}
    }
  },
  methods: {
    onSubmit() {
      const fieldNames = Object.keys(this.values);
      if (!fieldNames.length) {
        return alert("No input found.");
      }
      const passed = fieldNames.every(fieldName => {
        if (!this.conditions.schema.hasOwnProperty(fieldName)) {
          return false;
        }
        return this.conditions.schema[fieldName].toString() === this.values[fieldName].toString();
      });
      if (!passed) {
        return alert(`Some fields have wrong values. Test failed!`);
      }
      return alert('Test passed!');
    }
  },
  mounted() {
    console.log("mounted");
  }
}
</script>

<style scoped>

</style>
